import { apiHandler } from '@/services/apiHandler';
import { internalAxios } from '@/services/axiosInstances';
import type { KeywordLog, LanguageLog, MenuLog, PoiLog, SessionLog } from '@/services/dto';
import { LOGGING_ENDPOINTS } from '@/services/endpoints';

export const saveSessionLog = async (log: SessionLog) => {
    return apiHandler(async () => await internalAxios.post(LOGGING_ENDPOINTS.SESSION_LOGS, log));
};

export const saveMenuLog = async (log: MenuLog) => {
    return apiHandler(async () => await internalAxios.post(LOGGING_ENDPOINTS.MENU_LOGS, log));
};

export const savePoiLog = async (log: PoiLog) => {
    return apiHandler(async () => await internalAxios.post(LOGGING_ENDPOINTS.POI_LOGS, log));
};

export const saveKeywordLog = async (log: KeywordLog) => {
    return apiHandler(async () => await internalAxios.post(LOGGING_ENDPOINTS.KEYWORD_LOGS, log));
};

export const saveLanguageLog = async (log: LanguageLog) => {
    return apiHandler(async () => await internalAxios.post(LOGGING_ENDPOINTS.LANGUAGE_LOGS, log));
};
